import { render, staticRenderFns } from "./CompanyReport.vue?vue&type=template&id=3705280e&scoped=true"
import script from "./CompanyReport.vue?vue&type=script&lang=js"
export * from "./CompanyReport.vue?vue&type=script&lang=js"
import style0 from "./CompanyReport.vue?vue&type=style&index=0&id=3705280e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705280e",
  null
  
)

export default component.exports